import { render, staticRenderFns } from "./RollRecentElement.vue?vue&type=template&id=573491c0&scoped=true"
import script from "./RollRecentElement.vue?vue&type=script&lang=js"
export * from "./RollRecentElement.vue?vue&type=script&lang=js"
import style0 from "./RollRecentElement.vue?vue&type=style&index=0&id=573491c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573491c0",
  null
  
)

export default component.exports